export { default } from './Text'

export type { DefaultFontProps, DefaultFontStyles } from './Text'
